export class ForbiddenApiError extends Error {
  constructor(message?: string) {
    super(message ?? 'Forbidden error occurred')
    // Explicit name so the class can be identified post-minification. Kept in sync with
    // FORBIDDEN_API_ERROR_NAME in @ftr/ui-observability's ErrorHandlerService - it can't
    // be a shared import because api-shared already depends on ui-observability.
    this.name = 'ForbiddenApiError'
    Object.setPrototypeOf(this, ForbiddenApiError.prototype)
  }
}
